import { StreamActions } from "@hotwired/turbo"

StreamActions.close_modal = function() {
  $(".modal").modal("hide")
}

StreamActions.redirect = function () {
  const location = this.getAttribute("location")
  const delay = parseInt(this.getAttribute("delay") || 0)

  setTimeout(() => Turbo.visit(location), delay)
}
